var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vxe-table',{ref:"table",attrs:{"data":_vm.data,"loading":_vm.loading}},[_c('vxe-column',{attrs:{"fixed":"left","type":"seq","width":"40"}}),_c('vxe-column',{attrs:{"field":"dispatch.wave","title":"business.label.wave","width":"100"}}),_c('vxe-column',{attrs:{"field":"ordersCount","title":"business.label.ordersCount"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }